<template>
    <div class="pagination-box">
        <APagination v-if="listRef?.total>listRef?.per_page" v-model:current="listRef.current_page"
                     :page-size="listRef.per_page"
                     show-less-items
                     @change="loadPage"
                     :show-size-changer="false"
                     :total="listRef.total"/>
    </div>

</template>
<script setup lang="ts">
import {Pagination as APagination} from "ant-design-vue";
import {onMounted, ref, watch} from "vue";
import http from "@/utils/http";
import {replaceQuery} from "@/utils/url";

const props = withDefaults(defineProps<{
    url?: string,
    list?: any,
    query?: any,
    loading?: boolean,
}>(), {
    url: '',
    list: null,
    query: {},
    loading: false,
})

const listRef = ref(props.list)
const loading = ref(props.loading)

const emits = defineEmits(['update:list', 'update:loading', 'change'])
const isInit = ref(false)
const loadPage = async page => {
    if (loading.value) {
        return
    }
    loading.value = true
    try {
        listRef.value = await http.get(replaceQuery(props.url, {
            ...props.query,
            page,
        }))
        if (isInit.value) {
            emits('change', page)
        }
    } catch (e) {

    }
    loading.value = false
}

watch(listRef, (v) => {
    emits('update:list', listRef.value)
})

watch(loading, v => {
    emits('update:loading', v)
})

watch(() => props.list, () => {
    listRef.value = props.list
})

onMounted(async () => {
    if (!props.list) {
        await loadPage(1)
    }
    isInit.value = true
})
</script>

<style scoped lang="less">
.pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    :deep(.ant-pagination) {
        .ant-pagination-item-link {
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            background: #F3F5F7;
        }

        .ant-pagination-item, .ant-pagination-prev, .ant-pagination-next {
            background: #F3F5F7;
            overflow: hidden;
            border-radius: 6px;
            width: 30px;
            height: 30px;
            border: none;

            a {
                line-height: 30px;
            }

            &.ant-pagination-item-active {
                background: #989FA8;

                a {
                    color: #FFFFFF;
                }
            }
        }

        .ant-pagination-disabled {
            display: none;
        }

        .ant-pagination-options-quick-jumper {
            input {
                background: #F3F5F7;
                border: none;
                border-radius: 6px;
                width: 50px;
            }
        }
    }
}

</style>
